import * as React from 'react';
import moment from 'moment';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';

import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import { NameOf } from 'src/utils/NameOf';
import { PageProps } from 'src/models/common/ComponentProps';

import ReportHeader from 'src/components/common/ReportHeader';
import DataTable, { DataTableButtonExport, DataTableColumnProps, Filterer } from 'src/components/common/DataTable';
import StudentStatementReportDTO from 'src/models/report/StudentStatementReportDTO';
import ReportRequestDTO from 'src/models/datatable/ReportRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import ReportApiController from 'src/api/ReportApiController';
import ReportHeaderDTO from 'src/models/report/ReportHeaderDTO';
import './AdminReports.less';
import { Col, Icon, Popover, Row } from 'antd';
import { Grades } from 'src/constants/Grades';

interface StudentStatementReportProps extends PageProps<{}> {
}

interface StudentStatementReportState {
    isLoading: boolean;
    filterParams: Partial<ReportHeaderDTO>;
}

class StudentStatementReport extends React.Component<StudentStatementReportProps, StudentStatementReportState> {
    private standardDataTableRef: DataTable<StudentStatementReportDTO>;
    // private pageSize: number = 7;

    constructor(props) {
        super(props);
        bindAllOfThis(this, StudentStatementReport.prototype);

        this.state = {
            isLoading: false,
            filterParams: null
        };
    }

    private fetchData(requestState: ReportRequestDTO<ReportHeaderDTO>, checkEcho: () => boolean, callback: (response: TableResponseDTO<StudentStatementReportDTO>) => void): void {
        // Add custom filtering into the request
        requestState.filterData = this.state.filterParams as ReportHeaderDTO;

        // Show nothing in datatable if there are no filters, represented as {} from the reset function
        if (this.state.filterParams == null) {
            // Clear out the datatable as the clear button ends up here as well
            callback({ results: [], filteredCount: 0 } as TableResponseDTO<StudentStatementReportDTO>);
            return;
        }

        this.setState({ isLoading: true });
        ReportApiController.getStudentStatementReport(requestState)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                this.setState({
                    isLoading: false
                });

                callback(results.data);
            });
    }

    private handleOnReset() {
        this.setState({ filterParams: null }, () => this.standardDataTableRef.refresh());
    }

    private handleOnSubmit(filterParams: Partial<ReportHeaderDTO>) {
        this.setState({ filterParams }, () => this.standardDataTableRef.refresh());
    }

    private customTableColumns(): DataTableColumnProps<StudentStatementReportDTO>[] {
        let columns: DataTableColumnProps<StudentStatementReportDTO>[] = [
            DataTable.AdvancedColumns.Text(<Translate id='common.headers.firstName' />, "firstName", 200),
            DataTable.AdvancedColumns.Text(<Translate id='common.headers.lastName' />, "lastName", 200),
            DataTable.BetterColumns.Custom(<Translate id='common.headers.currentGrade' />, "currentGradeName", {
                width: 150,
                // Show name but sort on Ids
                sorter: (a, b) => a.currentGradeId - b.currentGradeId
            }),

            DataTable.BetterColumns.Custom("I Statements Completed", "statements", {
                render: record => {
                    if (record.statements.length === 0) {
                        return null;
                    }

                    return [
                        // Header
                        <div key={`${record.userId}header`} className="statement-grid">
                            <div className="grades">Activity Grade</div>
                            <div className="attachments">Attachments</div>
                            <div className="description">Statement</div>
                        </div>,
                        // Items
                        ...record.statements.map(x => {
                            return <div key={x.id} className="statement-grid">
                                <div className="grades">
                                    {x.activityGradeName}
                                </div>
                                <div className="attachments">
                                    {x.hasFilesAttached ? <Popover trigger="hover" content={"Student has uploaded files to this I Statement"}>
                                        <i className="far fa-file"></i>
                                    </Popover> : null}
                                </div>
                                <div className="description">
                                    {x.description}
                                </div>
                            </div>;
                        })
                    ];
                }
            })
        ];

        return columns;
    }

    render() {
        return (
            <div className="admin-report student-statement-report">
                <h2>I Statement Completion Report</h2>
                <h4>I Statement Completion Report provides quick access to review I Statements completed by students in your school. Reporting Period will be available in future. Grade column in the result table indicates student's current grade. In the results table, "I Statements Completed" would also have an indication for the grade.</h4>
                <p><Icon className="info-icon" type="info-circle" /> Click these icons for additional information.</p>
                <hr />
                <ReportHeader
                    reportingEvent={"I Statement"}
                    defaultSchoolYears={"Previous 1"}
                    isLoading={false}
                    onSubmit={this.handleOnSubmit}
                    onReset={this.handleOnReset}
                />
                <DataTable
                    ref={ref => this.standardDataTableRef = ref}
                    serverSide={true}
                    tableProps={{
                        // UserId is not unique
                        // rowKey: NameOf<StudentStatementReportDTO>("userId"),
                        loading: this.state.isLoading,
                        pagination: {
                            defaultPageSize: 100,
                            showTotal: DataTable.StandardTotalsRenderer,
                            showSizeChanger: true,
                            pageSizeOptions: ["10", "25", "100", "9999"],
                        }
                    }}
                    columns={this.customTableColumns()}
                    data={[]}
                    fetchData={this.fetchData}
                    buttonBar={[
                        new DataTableButtonExport("I Statement Completion Report")
                    ]}
                />
            </div>
        );
    }
}

export default StudentStatementReport;



// WEBPACK FOOTER //
// ./src/pages/admin/reports/StudentStatementReport.tsx